import { Directive, ElementRef, HostListener } from '@angular/core';
import { FlatPickrOutputOptions } from 'angularx-flatpickr/lib/flatpickr.directive';

@Directive({
    selector: 'input[mwlFlatpickr]'
})

// needed, when typing hours and minutes manually in their inputs, because flatpickr ignores it
export class FlatpickrDirective {
    private flatpickrInstance: FlatPickrOutputOptions['instance'];

    constructor(
        public el: ElementRef,
    ) { }

    @HostListener('flatpickrReady', ['$event'])
    onFlatpickrReady(fp: FlatPickrOutputOptions) {
        this.flatpickrInstance = fp.instance;

        if (this.flatpickrInstance.hourElement && this.flatpickrInstance.minuteElement) {
            this.flatpickrInstance.hourElement.addEventListener('input', this.setDate);
            this.flatpickrInstance.minuteElement.addEventListener('input', this.setDate);
        }
    }

    setDate = (event: InputEvent) => {
        const hours = parseInt(this.flatpickrInstance.hourElement.value, 10) || 0;
        const minutes = parseInt(this.flatpickrInstance.minuteElement.value, 10) || 0;
        const date = this.flatpickrInstance.selectedDates[0];

        date.setHours(Math.min(Math.max(hours, 0), 23));
        date.setMinutes(Math.min(Math.max(minutes, 0), 59));
        date.setSeconds(0, 0);

        this.flatpickrInstance.setDate(date, true);
    };
}
